import { createFileRoute } from '@tanstack/react-router';

import { requireRoute } from '@/router/guards';
import InstitutionEdit from '@/ui/pages/InstitutionEdit/InstitutionEdit';

export const Route = createFileRoute('/_dashboard/institutions/$id/edit')({
  beforeLoad: requireRoute('/institutions/$id/edit'),
  component: InstitutionEdit,
});
